import React from 'react';
import EmptyState from './EmptyState';
import { EMPTY_STATE_ICONS } from './emptyStateIcons';

export default function ChangelogEmptyState() {
	return (
		<EmptyState
			className="changelog-empty"
			icon={EMPTY_STATE_ICONS.changelogEmpty}
			iconAlt="No log entries"
			message="No activity has been logged yet."
		/>
	);
}
